import { Injectable } from '@angular/core';
import { AnnouncementDialogComponent } from '../components/announcement-dialog/announcement-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import AirtableService from './airtable.service';

@Injectable({ providedIn: 'root' })
export class AnnouncementService {
  constructor(private dialog: MatDialog, private airtable: AirtableService) {}

  showActiveAnnouncement() {
    this.airtable
      .getActiveAnnouncement()
      .subscribe(({ id, title, details }: Announcement) => {
        if (id && !this.checkAlreadyShown(id)) {
          this.dialog.open(AnnouncementDialogComponent, {
            data: {
              title,
              details,
            },
          });

          this.setAlreadyShown(id);
        }
      });
  }

  checkAlreadyShown(id: string) {
    return localStorage.getItem(id) !== null;
  }

  setAlreadyShown(id: string) {
    localStorage.setItem(id, id);
  }
}

export interface Announcement {
  id: string;
  title: string;
  details: string;
  active: boolean;
}
